import { z } from 'zod';
import { ID, Url } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { billingStatsListResponseSchema } from '../models/billingStats.schema';
import {
  billingStatsPayloadSchema,
  billingStatsQuerySchema,
} from './getStats.schema';

export type BillingStatsPayload = Partial<{
  filters: Partial<{
    beginDate: string;
    endDate: string;
    queues: (Url | null)[];
    organizations: Url[]; // Allowed only if endpoint === 'organization_groups'
  }>;
  groupBy: Array<'organization' | 'queue' | 'month' | 'week'>;
  orderBy: Array<'-billable_pages' | '-billable_documents'>;
}>;

export type BillingStatsQuery = PaginationQuery;

export const getStats =
  (endpoint: 'organizations' | 'organization_groups') =>
  (id: ID, payload: BillingStatsPayload, query: BillingStatsQuery) => {
    return {
      endpoint: `/${endpoint}/${id}/billing_stats`,
      method: 'POST',
      responseSchema: billingStatsListResponseSchema,
      payloadSchema: billingStatsPayloadSchema,
      payload,
      querySchema: billingStatsQuerySchema.and(
            z.object({ includeTotal: z.boolean().optional() })
          ),
      query: { ...query, includeTotal: true }
    } as const;
  };
